import { translate } from '@jsverse/transloco';
export interface ConsumedReviewsBreakdown {
    reviewedIds: number[];
    taskTypeDistribution: TaskReviewStatistics[];
    taskReviewedCounts: TaskReviewStatistics[];
}

export interface TaskReviewStatistics {
    taskId: number;
    totalReviewed: number;
    type: TypeTaskDistribution;
    count: number;
}

export enum TypeTaskDistribution {
    ASSESSMENT_LEVEL_TASK = 'ASSESSMENT_LEVEL_TASK',
    ADHOC_TASK = 'ADHOC_TASK',
}

export class TypeTaskDistributionHelper {
    static getTypeTaskDistributionTypeLocale(event: TypeTaskDistribution): string {
        switch (event) {
            case TypeTaskDistribution.ASSESSMENT_LEVEL_TASK:
                return translate('TASK_TRACKER.ASSESSMENT_TASKS_REVIEWS');
            case TypeTaskDistribution.ADHOC_TASK:
                return translate('TASK_TRACKER.AD_HOC_TASKS_REVIEWS');
            default:
                return event + '';
        }
    }
}
